import { getOr } from 'lodash/fp';

const getOrNull = getOr(null);
const selectChoosableComparerProductId = getOrNull('choosable.comparerProductId');

export default selectChoosableComparerProductId;
